import faviconAlfa from "./aConsierge/images/favicon.png";
import faviconOpen from "./oConsierge/images/favicon.svg";
import faviconGpb from "./gpbConsierge/images/favicon.svg";
import faviconLifestyle from "./oLifestyle/images/favicon.png";
import faviconSWMLifestyle from "./swmLifestyle/images/favicon.png";
import faviconOnlyAssist from "./onlyAssist/images/favicon.png";
import React from "react";
import screenAlfa from './aConsierge/images/screen1@x2.png';
import screenOpen from './oConsierge/images/screen1@x3.png';
import screenGpb from './gpbConsierge/images/screen1@x3.png';
import screenLifestyle from './oLifestyle/images/screen1@x3.png';
import screenSWMLifestyle from './swmLifestyle/images/screen1@x3.png';
import {AppDescriptionsType} from '../../dto/appdescriptions.dto';
import AlfaButton from "./onlyAssist/alfabutton/alfabutton.component";

export const AppDescriptions: AppDescriptionsType = {
    'a_concierge': {
        metaTags: [
            <title>А-Консьерж</title>,
            <meta name="description" content="А-Консьерж: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="А-Консьерж"/>,
            <meta property="og:title" content = "А-Консьерж: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/a_concierge" />,
            <link href={faviconAlfa} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconAlfa} />
        ],
        title: 'Будем знакомы, А-Консьерж',
        description: `Это личный помощник в вашем смартфоне, который помогает в решении любых вопросов 24/7.
                        <br/><br/>
                        Через А-Консьерж можно:
                        <br/><br/>
                        <ul>
                            <li>получать юридические консультации;</li>
                            <li>заказывать билеты;</li>
                            <li>брать в прокат автомобили или арендовать другой транспорт;</li>
                            <li>бронировать номера в отелях;</li>
                            <li>резервировать столики в ресторанах, барах или клубах;</li>
                            <li>доставлять подарки или цветы в любую точку мира;</li>
                            <li>получать медицинские консультации от практикующих врачей.</li>
                        </ul>
                        <br/><br/>`,
        screen: screenAlfa,
        appStoreLink: "https://apps.apple.com/ru/app/%D0%B0-%D0%BA%D0%BE%D0%BD%D1%81%D1%8C%D0%B5%D1%80%D0%B6/id1409566434",
        googlePlayLink: '',
        appGalleryLink: 'https://appgallery.huawei.com/#/app/C108761793',
        apkLink: 'https://link.konsierge.com/a_consierge',
        apkName: 'a_consierge.apk',
        askQuestions: `Наши контакты:
        <br/>
        <a href="mailto:alfa@knsrg.ru">alfa@knsrg.ru</a>`
    },
    'o_concierge': {
        metaTags: [
            <title>О.Консьерж</title>,
            <meta name="description" content="О.Консьерж: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="О.Консьерж"/>,
            <meta property="og:title" content = "О.Консьерж: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/o_concierge" />,
            <link href={faviconOpen} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconOpen} />
        ],
        title: 'Добро пожаловать в О.Консьерж',
        description: `Мобильное приложение, с помощью которого вы можете общаться с профессиональной
                консьерж-службой, которая поможет вам в решении любых вопросов
                24 часа в сутки 365 дней в году.
                <br /><br />
                Вы бесплатно получите необходимую информацию и помощь в любой точке мира:
                <br /><br />
                <ul>
                    <li>юридические консультации по различным областям права</li>
                    <li>посещение бизнес-залов в аэропортах по QR-коду</li>
                    <li>бронирование билетов на любой вид транспорта, регистрация на рейсы авиакомпаний</li>
                    <li>аренда транспорта, прокат автомобилей и других средств передвижения</li>
                    <li>бронирование номеров в отелях и на мировых курортах</li>
                    <li>рекомендация и бронирование столов в ресторанах, барах и клубах</li>
                    <li>доставка подарков и цветов в любую точку мира</li>
                    <li>медицинские консультации от практикующих врачей</li>
                </ul>
                <br /><br />`,
        screen: screenOpen,
        appStoreLink: "https://apps.apple.com/ru/app/%D0%BE-%D0%BA%D0%BE%D0%BD%D1%81%D1%8C%D0%B5%D1%80%D0%B6/id1286643845",
        googlePlayLink: "https://play.google.com/store/apps/details?id=ru.konsierge.konsierge",
        appGalleryLink: 'https://appgallery.huawei.com/#/app/C108761427',
        apkLink: 'https://link.konsierge.com/o.consierge',
        apkName: '',
        askQuestions: `Остались вопросы? Звоните <a href="tel:+74957750566">+7 495 775 05 66</a>, <a href="tel:88007000566">8 800 700 05 66</a>, пишите <a href="mailto:open@knsrg.ru">open@knsrg.ru</a> мы на связи 😊`
    },
    'gpb_concierge': {
        metaTags: [
            <title>Премиум Консьерж</title>,
            <meta name="description" content="Премиум Консьерж: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="Премиум Консьерж"/>,
            <meta property="og:title" content = "Премиум Консьерж: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/gpb_concierge" />,
            <link href={faviconGpb} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconGpb} />
        ],
        title: 'Добро пожаловать в Премиум Консьерж',
        description: `Мобильное приложение, с помощью которого вы можете общаться с профессиональной
                консьерж-службой, которая поможет вам в решении любых вопросов
                24 часа в сутки 365 дней в году.
                <br /><br />
                Вы бесплатно получите необходимую информацию и помощь в любой точке мира:
                <br /><br />
                <ul>
                    <li>юридические консультации по различным областям права</li>
                    <li>посещение бизнес-залов в аэропортах по QR-коду</li>
                    <li>бронирование билетов на любой вид транспорта, регистрация на рейсы авиакомпаний</li>
                    <li>аренда транспорта, прокат автомобилей и других средств передвижения</li>
                    <li>бронирование номеров в отелях и на мировых курортах</li>
                    <li>рекомендация и бронирование столов в ресторанах, барах и клубах</li>
                    <li>доставка подарков и цветов в любую точку мира</li>
                    <li>медицинские консультации от практикующих врачей</li>
                </ul>
                <br /><br />`,
        screen: screenGpb,
        appStoreLink: "https://apps.apple.com/ru/app/%D0%B3%D0%BF%D0%B1-%D0%BA%D0%BE%D0%BD%D1%81%D1%8C%D0%B5%D1%80%D0%B6/id1455820702",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.konsierge.gazprom",
        appGalleryLink: "https://appgallery.huawei.ru/app/C108726451",
        apkLink: 'https://link.konsierge.com/gpb-consierge',
        apkName: '',
        askQuestions: `Остались вопросы? Звоните <a href="tel:+74952298861">+7 495 229 88 61</a>, пишите <a href="mailto:gpb@knsrg.ru">gpb@knsrg.ru</a> мы на связи 😊`
    },
    'o_lifestyle': {
        metaTags: [
            <title>O.Lifestyle</title>,
            <meta name="description" content="O.Lifestyle: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="O.Lifestyle"/>,
            <meta property="og:title" content = "O.Lifestyle: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/o_lifestyle" />,
            <link href={faviconLifestyle} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconLifestyle} />
        ],
        title: 'Добро пожаловать в O.Lifestyle',
        description: `Мобильное приложение, с помощью которого вы можете общаться с профессиональной
                консьерж-службой, которая поможет вам в решении любых вопросов
                24 часа в сутки 365 дней в году.
                <br /><br />
                Вы бесплатно получите необходимую информацию и помощь в любой точке мира:
                <br /><br />
                <ul>
                    <li>юридические консультации по различным областям права</li>
                    <li>посещение бизнес-залов в аэропортах по QR-коду</li>
                    <li>бронирование билетов на любой вид транспорта, регистрация на рейсы авиакомпаний</li>
                    <li>аренда транспорта, прокат автомобилей и других средств передвижения</li>
                    <li>бронирование номеров в отелях и на мировых курортах</li>
                    <li>рекомендация и бронирование столов в ресторанах, барах и клубах</li>
                    <li>доставка подарков и цветов в любую точку мира</li>
                    <li>медицинские консультации от практикующих врачей</li>
                </ul>
                <br /><br />`,
        screen: screenLifestyle,
        appStoreLink: "https://apps.apple.com/ru/app/o-lifestyle/id1466045522",
        googlePlayLink: '',
        appGalleryLink: 'https://appgallery.huawei.com/#/app/C108726567',
        apkLink: 'https://link.konsierge.com/o.lifestyle',
        apkName: 'o.lifestyle.apk',
        askQuestions: `Остались вопросы? Звоните <a href="tel:+74959098048">+7 495 909 80 48</a>,
 пишите <a href="mailto:pb.open@knsrg.ru">pb.open@knsrg.ru</a> мы на связи 😊`
    },
    'swm_lifestyle': {
        metaTags: [
            <title>Консьерж-сервис Совкомбанка</title>,
            <meta name="description" content="Консьерж-сервис Совкомбанка: скачивание приложения"/>,
            <meta property="og:site_name" content="Консьерж-сервис Совкомбанка"/>,
            <meta property="og:title" content = "Консьерж-сервис Совкомбанка: скачивание приложения" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/swm_lifestyle" />,
            <link href={faviconSWMLifestyle} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconSWMLifestyle} />
        ],
        title: 'Добро пожаловать в консьерж-сервис Совкомбанка',
        description: `Мобильное приложение, с помощью которого вы можете общаться с профессиональной
                консьерж-службой, которая поможет вам в решении любых вопросов
                24 часа в сутки 365 дней в году.
                <br /><br />
                Вы бесплатно получите необходимую информацию и помощь в любой точке мира:
                <br /><br />
                <ul>
                    <li>юридические консультации по различным областям права</li>
                    <li>бронирование билетов на любой вид транспорта, регистрация на рейсы авиакомпаний</li>
                    <li>аренда транспорта, прокат автомобилей и других средств передвижения</li>
                    <li>бронирование номеров в отелях и на мировых курортах</li>
                    <li>рекомендация и бронирование столов в ресторанах, барах и клубах</li>
                    <li>доставка подарков и цветов в любую точку мира</li>
                    <li>медицинские консультации от практикующих врачей</li>
                </ul>
                <br /><br />`,
        screen: screenSWMLifestyle,
        appStoreLink: "https://apps.apple.com/us/app/sv-concierge/id6756060919",
        googlePlayLink: 'https://link.konsierge.com/MXwF1',
        appGalleryLink: '',
        apkLink: 'https://link.konsierge.com/swm.lifestyle',
        apkName: 'swm.lifestyle.apk',
        askQuestions: `Остались вопросы? Звоните <a href="tel:+74997531064">+7 499 753 10 64</a>,
 пишите <a href="mailto:swm@konsierge.com">swm@konsierge.com</a> мы на связи 😊`
    },
    'sv_concierge': {
        metaTags: [
            <title>SV Concierge</title>,
            <meta name="description" content="SV Concierge: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="SV Concierge"/>,
            <meta property="og:title" content = "SV Concierge: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/sv_concierge" />,
            <link href={faviconSWMLifestyle} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconSWMLifestyle} />
        ],
        title: 'SV Concierge',
        description: `Мобильное приложение, с помощью которого вы можете общаться с профессиональной
                консьерж-службой, которая поможет вам в решении любых вопросов
                24 часа в сутки 365 дней в году.
                <br /><br />
                Вы бесплатно получите необходимую информацию и помощь в любой точке мира:
                <br /><br />
                <ul>
                    <li>юридические консультации по различным областям права</li>
                    <li>бронирование билетов на любой вид транспорта, регистрация на рейсы авиакомпаний</li>
                    <li>аренда транспорта, прокат автомобилей и других средств передвижения</li>
                    <li>бронирование номеров в отелях и на мировых курортах</li>
                    <li>рекомендация и бронирование столов в ресторанах, барах и клубах</li>
                    <li>доставка подарков и цветов в любую точку мира</li>
                </ul>
                <br /><br />`,
        screen: screenSWMLifestyle,
        appStoreLink: "",
        googlePlayLink: '',
        appGalleryLink: '',
        apkLink: '',
        apkName: '',
        askQuestions: `Остались вопросы? Звоните <a href="tel:+74997531064">+7 499 753 10 64</a> мы на связи 😊
                <br/>
                <a href="https://knsrg.ru/docs/svconcierge/public-offer" target="_blank">Оферта</a>`
    },
    'only_assist': {
        metaTags: [
            <title>Only Assist</title>,
            <meta name="description" content="Only Assist: скачивание приложения для Андроид"/>,
            <meta property="og:site_name" content="Only Assist"/>,
            <meta property="og:title" content = "Only Assist: скачивание приложения для Андроид" />,
            <meta property="og:type" content = "article" />,
            <meta property="og:image" content = "https://konsierge.com/images/Konsierge-SocialMedia-1200x630.png" />,
            <meta property="og:url" content="https://knsrg.ru/only_assist" />,
            <link href={faviconOnlyAssist} rel="shortcut icon" type="image/x-icon" />,
            <link rel="icon" href={faviconOnlyAssist} />
        ],
        title: 'Консьерж сервис Альфа-Банка!',
        description: `Личный помощник в вашем смартфоне, который помогает в решении любых вопросов 24/7
                        <br/>`,
        appStoreLink: "https://apps.apple.com/ru/app/konsierge/id946404265",
        askQuestions: `Остались вопросы? Звоните <a href="tel:88005053139">8 800 505 31 39</a>,
 пишите <a href="mailto:ab@knsrg.ru">ab@knsrg.ru</a> мы на связи 😊`,
        additionalElement: <AlfaButton/>
    },
};

export const AppServices = {
    'a_concierge': '',
    'o_concierge': '',
    'gpb_concierge': '',
    'o_lifestyle': '',
    'swm_lifestyle': '',
    'sv_concierge': '',
    'only_assist': 'alfa_ru'
}